module.exports = __webpack_public_path__ + "img/P4-0-4.4773afb6.svg";